import { createFileRoute } from '@tanstack/react-router';
import { ScreeningIndividualsTable } from '../components/ScreeningIndividualsTable.tsx';

export const Route = createFileRoute('/screening/$screeningId/individuals/')({
  component: ScreeningIndividuals,
});

function ScreeningIndividuals() {
  const { screeningId } = Route.useParams();

  return <ScreeningIndividualsTable screeningCaseId={screeningId} />;
}
